import React, { useState } from "react";
import config from "../config";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const ExamQuestionCard = ({
  question,
  questionIndex,
  selectedAnswer,
  totalQuestions,
  onAnswerSelect,
  onPrevious,
  onNext,
  onMarkReview,
  onClearResponse,
  showBackButton = false,
  allowMarkForReview = false
}) => {
  const [previewImage, setPreviewImage] = useState(null);

  const handleAnswerChange = (optionIndex) => {
    onAnswerSelect(questionIndex, optionIndex);
  };

  const getImageSrc = (image) =>
    image && image.startsWith("/media/") ? `${config.mediaUrl}${image}` : image;

  return (
    <div className="card question-box">
      <h3>
        Question {questionIndex + 1}
        {question.is_mandatory === 1 && (
          <span style={{ color: "red", fontWeight: "bold" }}>*</span>
        )}
      </h3>

      <p>{question.q}</p>

      {question.question_image && (
        <div style={{ textAlign: "left", marginTop: "3px", marginBottom: "10px" }}>
          <img
            src={`${config.mediaUrl}${question.question_image}`}
            alt="Question Illustration"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "8px",
              border: "1px solid #ddd",
              marginTop: "10px"
            }}
          />
        </div>
      )}

      <div className="options">
        {question.question_type_id === 1 &&
          question.options.map((option, index) => {
            const imageSrc = getImageSrc(option.image);

            return (
              <label
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: "10px",
                  cursor: "pointer"
                }}
              >
                <Radio
                  name={`question-${questionIndex}`}
                  checked={selectedAnswer === index}
                  onChange={() => handleAnswerChange(index)}
                  sx={{
                    color: "#0191c8",
                    "&.Mui-checked": { color: "#0191c8" },
                    "&:hover": { backgroundColor: "rgba(1,145,200,0.08)" }
                  }}
                />
                <span style={{ flex: 1, wordBreak: "break-word" }}>
                  {option.text}
                </span>

                {imageSrc && (
                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                  >
                    <img
                      src={imageSrc}
                      alt={`Option ${index + 1}`}
                      style={{
                        width: "100px",
                        height: "70px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                        borderRadius: "4px"
                      }}
                    />

                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setPreviewImage(imageSrc);
                      }}
                      style={{
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        boxShadow: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <VisibilityIcon sx={{ color: "#0191c8", fontSize: 28 }} />
                    </button>
                  </div>
                )}
              </label>
            );
          })}

        {question.question_type_id === 2 &&
          question.options.map((option, index) => {
            const imageSrc = getImageSrc(option.image);

            return (
              <label key={index}>
                <Checkbox
                  name={`question-${questionIndex}-${index}`}
                  checked={
                    Array.isArray(selectedAnswer)
                      ? selectedAnswer.includes(index)
                      : false
                  }
                  onChange={() => handleAnswerChange(index)}
                  sx={{
                    color: "#0191c8",
                    "&.Mui-checked": { color: "#0191c8" },
                    "&:hover": { backgroundColor: "rgba(1,145,200,0.08)" }
                  }}
                />
                <span>{option.text}</span>
                {imageSrc && (
                  <img
                    src={imageSrc}
                    alt={`Option ${index + 1}`}
                    style={{ maxWidth: "100px", marginLeft: "10px" }}
                  />
                )}
              </label>
            );
          })}

        {question.question_type_id === 3 && (
          <div>
            <input
              type="text"
              value={selectedAnswer || ""}
              onChange={(e) => handleAnswerChange(e.target.value)}
              placeholder="Type your answer here"
              style={{ width: "100%", padding: "8px", marginTop: "5px" }}
            />

            {question.options &&
              question.options.map((option, index) => {
                const imageSrc = getImageSrc(option.image);

                return (
                  imageSrc && (
                    <img
                      key={index}
                      src={imageSrc}
                      alt={`Option ${index + 1}`}
                      style={{ maxWidth: "100px", marginTop: "10px" }}
                    />
                  )
                );
              })}
          </div>
        )}
      </div>

      <Dialog
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E7E8E9",
            padding: "10px 24px"
          }}
        >
          <Typography variant="h6">View Image</Typography>

          <IconButton onClick={() => setPreviewImage(null)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2
          }}
        >
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "500px",
                objectFit: "contain"
              }}
            />
          )}
        </DialogContent>

        <DialogActions sx={{ borderTop: "1px solid #E7E8E9", padding: "1rem" }}>
          <button
            className="btn btn-outlineWhite"
            onClick={() => setPreviewImage(null)}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>

      <div className="actions">
        {showBackButton && (
          <button
            className="e-btn btn-outlineWhite"
            onClick={onPrevious}
            disabled={questionIndex === 0}
          >
            Back
          </button>
        )}

        {allowMarkForReview && (
          <button
            className="e-btn mark"
            onClick={() => onMarkReview(questionIndex)}
          >
            Mark for Review
          </button>
        )}

        <button
          className="e-btn clear"
          onClick={() => onClearResponse(questionIndex)}
        >
          <i className="fa fa-trash pr-1"></i> Clear Response
        </button>

        <button
          className="e-btn BlueBtn"
          onClick={onNext}
          disabled={questionIndex === totalQuestions - 1}
        >
          Save & Next
        </button>
      </div>
    </div>
  );
};

export default ExamQuestionCard;
